import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrganizationService } from '@aid/core/services/organization.service';
import { UserService } from '@aid/core/services';

@Injectable({
  providedIn: 'root'
})
export class BillingGuard {
  constructor(
    private router: Router,
    private organizationService: OrganizationService,
    private userService: UserService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (
      !this.userService.isOwner ||
      this.organizationService.requireOrganization().withoutSubscription
    ) {
      this.router.navigate([
        this.organizationService.requireOrganization().slug
      ]);
      return false;
    }

    return true;
  }
}
